export default __webpack_public_path__ + "static/donald-7cc485f714f010f76e5c914dc8a191a5.png";